var modules_56feba8c = {"inputWrapper":"_14da6wd","searchInput":"_15nphh4"};
import "../../../assets/CADiK8Ja.css";

export { modules_56feba8c as default };
//# sourceMappingURL=TextInput.module.less.js.map
